export default "__VITE_ASSET__BprcC_Pz__"